import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../../environments/environment";
import { ProviderSpot, ProviderSpotDto } from "../../../models/provider-parking/provider-spot.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperProviderSpotService } from '../../../mappers/provider-parking/mapper-provider-spot.service';

@Injectable({
    providedIn: 'root',
})
export class ApiProviderSpotService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperProviderSpotService
    ) { }

    /**
     * ดึงข้อมูลรายการจุดให้บริการทั้งหมด
     */
    getProviderSpots(): Observable<ProviderSpot[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<ProviderSpotDto[]>(
            '/backoffice/GetProviderGate',
            'GET',
            this.baseUrl,
            {
                labelLog: 'GetProviderGate',
                token: token,
                headerOnly: false,
                isConsoleLog: true
            }
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapProviderSpotFromDto(dto)))
        );
    }

    /**
     * สร้างหรือแก้ไขข้อมูลจุดให้บริการ
     */
    createProviderSpot(payload: ProviderSpot): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapper.mapProviderSpotToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateProviderGate',
            'POST',
            this.baseUrl,
            {
                labelLog: 'CreateProviderGate',
                token: token,
                headerOnly: false,
                isConsoleLog: true,
                body: dto
            }
        );
    }
}
